// extracted by mini-css-extract-plugin
module.exports = {"partnerLoadingIcon":"_2iJAO","disabledPartnerItem":"_3IBCk"};